module.exports = __webpack_public_path__ + "img/25.3d3cbf1e.png";